import React from "react";

import tiktok from "images/social/tiktok.svg";

import { classnames, SelectField } from "@culturehq/components";

import { useFieldsLabels } from "app/hooks";
import { t, Trans } from "app/utils";

import ScheduleForLater from "components/common/ScheduleForLater";
import SelectTags from "components/post/SelectTags";
import formatLinkedinMention from "components/editor/formatLinkedinMention";
import LazyEditor from "components/editor/LazyEditor";
import TiktokMessage from "./TiktokMessage";
import SocialMediaTab from "./SocialMediaTab";

const PersonalAccountsFields = ({
  isTiktokShareable,
  personalAccounts,
  selectedAccounts,
  onSelectSocialMedia,
  uniqueSocialMedia,
  activeSocialMediaText,
  onChangeActiveText,
  shareMessage,
  onShareMessageChanged,
  onShareWithChanged,
  selectedOptions,
  schedulePostType,
  onChooseSchedulePostChanged,
  timezoneOffset,
  scheduleAt,
  handleScheduleAtChange,
  handleOffsetChange,
  editorRef
}) => {
  const labels = useFieldsLabels();

  return (
    <>
      <SelectField
        ariaLabel={t("Choose your accounts")}
        className="multiselector"
        multiple
        name="accounts"
        options={personalAccounts}
        onChange={onSelectSocialMedia}
        required
        value={selectedAccounts}
      >
        <h4 className="FieldLabel"><Trans>Choose your accounts</Trans></h4>
      </SelectField>
      {uniqueSocialMedia.find(socialMedia => socialMedia.category === "TikTok") && (
        <div className="Disclaimer">
          <img className="social-icon" src={tiktok} alt="TikTok" />
          <i>
            <Trans>
              You will receive a mobile notification from TikTok for you to finalize your post
            </Trans>
          </i>
        </div>
      )}
      <h4><Trans>Caption</Trans></h4>
      <ul role="tablist" aria-label={t("Social Media options")} className="nav nav-tabs">
        {uniqueSocialMedia.map(socialMedia => (
          <SocialMediaTab
            key={socialMedia.category}
            socialMediaSelected={socialMedia.category}
            activeSocialMediaText={activeSocialMediaText}
            onChangeActiveText={onChangeActiveText}
          />
        ))}
      </ul>
      <div className="LinkedinShareModal approved-for-social-container">
        <LazyEditor
          ref={editorRef}
          className={classnames("textarea", `textarea-${activeSocialMediaText}`)}
          initialValue={shareMessage}
          sections={["mention"]}
          placeholder={t("Put your message here...")}
          suggestionStrategy={activeSocialMediaText}
          readOnly={activeSocialMediaText === "TikTok"}
          onChange={editoryBody => {
            const value = formatLinkedinMention(JSON.parse(editoryBody));
            onShareMessageChanged(value);
          }}
        />
      </div>
      {activeSocialMediaText === "TikTok" && (
        <TiktokMessage isTiktokShareable={isTiktokShareable} />
      )}
      <ScheduleForLater
        handleOffsetChange={handleOffsetChange}
        handleScheduleAtChange={handleScheduleAtChange}
        onChooseSchedulePostChanged={onChooseSchedulePostChanged}
        schedulePostType={schedulePostType}
        scheduleAt={scheduleAt}
        timezoneOffset={timezoneOffset}
      />
      <div className="tags-container">
        <h4>
          <Trans>
            Select who is going to be notified to engage with this post
            {" "}
            <span className="legend">
              (people,
              interests,
              {" "}
              {labels.departments.plural.toLowerCase()},
              etc.)
            </span>
          </Trans>
        </h4>
        <SelectTags
          creatable={false}
          normalDesign={false}
          onShareWithChanged={onShareWithChanged}
          placeholder={t("Select users")}
          selectedOptions={selectedOptions}
          withUsers
          wholeCompany
        />
        {selectedOptions.length > 0 && <p className="Story-Share-Modal__explanation"><Trans>* Sending an in-app notification and email to these users</Trans></p>}
      </div>
    </>
  );
};

export default PersonalAccountsFields;
